export default function makeProjectName(string) {
    return string.replace(/ /g, "_").toLowerCase();
}
